import {
  SET_SELECTED_DATE,
  SET_SELECTED_RESERVATION_IDS,
  SET_SELECTED_ROOM_ID,
  SET_SELECTED_RESERVATION_ID,
  FETCH_ROOMS_SUCCESS,
  CREATE_ROOM,
  UPDATE_ROOM,
  UPLOAD_ROOM_PICTURE,
  FETCH_RESERVATIONS_MONTH,
  CREATE_RESERVATION,
  UPDATE_RESERVATION,
  FETCH_RESERVATION_DETAILS,
  DELETE_SINGLE_RESERVATION,
  REMOVE_RESERVATION_DATE,
} from "../actions/types";
import { produce } from "immer";

const initialState = {
  Rooms: [],
  Reservations: [],
  ReservationDetails: [],
  selectedDate: "",
  selectedIds: [],
  selectedRoomId: -1,
  selectedReservationId: -1,
};

const roomsReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    var key = 0;
    switch (action.type) {
      case SET_SELECTED_DATE:
        draft.selectedDate = action.payload;
        break;
      case SET_SELECTED_RESERVATION_IDS:
        draft.selectedIds = action.payload;
        break;
      case SET_SELECTED_ROOM_ID:
        draft.selectedRoomId = action.payload;
        break;
      case SET_SELECTED_RESERVATION_ID:
        draft.selectedReservationId = action.payload;
        break;
      case FETCH_ROOMS_SUCCESS:
        draft.Rooms = action.payload;
        break;
      case CREATE_ROOM:
        draft.Rooms = [...draft.Rooms, action.payload];
        break;
      case UPDATE_ROOM:
        key = draft.Rooms.findIndex((R) => R.id === action.payload.id);
        draft.Rooms[key] = action.payload;
        break;
      case UPLOAD_ROOM_PICTURE:
        key = draft.Rooms.findIndex((R) => R.id === action.payload.id);
        draft.Rooms[key].picture = action.payload.fileName;
        break;
      case FETCH_RESERVATIONS_MONTH:
        draft.Reservations = action.payload;
        break;
      case CREATE_RESERVATION:
        key = draft.ReservationDetails.findIndex(
          (RD) => RD.id === action.payload.detailsId
        );
        if (key === -1) {
          draft.ReservationDetails = [
            ...draft.ReservationDetails,
            {
              id: parseInt(action.payload.detailsId),
              title: action.payload.title,
            },
          ];
        }
        draft.Reservations = [...draft.Reservations, action.payload];
        break;
      case UPDATE_RESERVATION:
        key = draft.ReservationDetails.findIndex(
          (RD) => RD.id === action.payload.detailsId
        );
        if (key === -1) {
          draft.ReservationDetails = [
            ...draft.ReservationDetails,
            {
              id: parseInt(action.payload.detailsId),
              title: action.payload.title,
            },
          ];
        }
        key = draft.Reservations.findIndex(R => R.id === action.payload.id)
        draft.Reservations[key] = {...draft.Reservations[key], ...action.payload};
        break;
      case FETCH_RESERVATION_DETAILS:
        draft.ReservationDetails = action.payload
        break
      case DELETE_SINGLE_RESERVATION:
        key = draft.Reservations.findIndex(
          (R) => parseInt(R.id) === parseInt(action.payload.id)
        );
        draft = { Reservations: draft.Reservations.splice(key, 1) };
        draft.selectedReservationId = -1
        break
      case REMOVE_RESERVATION_DATE:
        key = draft.Reservations.findIndex((R) => parseInt(R.id) === parseInt(action.payload.id));
        const subkey = draft.Reservations[key].dates.findIndex(D => D === action.payload.date)
        draft.Reservations[key].dates.splice(subkey, 1);
        draft.selectedReservationId = -1;
        break
      default:
        return draft;
    }
  });

export default roomsReducer;
